import { useState, useEffect, useContext } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Row } from "react-bootstrap";
import ContributionsData from "../pages/ContributionsData";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import FindUser from "../pages/FindUser";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import { useNavigate } from "react-router-dom";

export default function Performers() {
  const { userData } = useContext(UserDataContext);
  const [value, setValue] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const savedTab = localStorage.getItem("selectedTabPerformers");
    if (savedTab) {
      setValue(parseInt(savedTab, 10));
    }
  }, []);

  useEffect(() => {
    if (userData && !["1", "3"].includes(userData.permId)) {
      navigate("/nopermission");
    }
  }, [userData]);

  return (
    <div>
      <VN userData={userData} />
      <ContributionsData />
    </div>
  );
}
